import React from 'react';
import { Label, InfoIcon, colors, ArrowIcon } from '@commonsku/styles';
import LabelledRadio from './LabelledRadio';

const labelledRadioStyle: React.CSSProperties = {
  marginBottom: '1rem',
};
const styleContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
};
const styleHeaderStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
};
const styleLabelStyle: React.CSSProperties = {
    width: 'unset',
};
const infoBoxStyle: React.CSSProperties = {
    background: colors.navy[10],
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '8px',
};
const infoTextStyle: React.CSSProperties = {
    color: colors.navy[80],
    lineHeight: '24px',
};
const templatesContainerStyle = {
  display: 'flex',
};
const templatesLabelStyle = {
  display: 'inline',
  lineHeight: '24px',
};
const templatesBadgeStyle = {
  display: 'inline',
  fontWeight: 'bold',
  color: colors.pink[60],
  lineHeight: '24px',
};
const templatesArrowStyle = {
  marginLeft: 8,
  minWidth: 24,
};

export const TemplatesOption = (
  <div style={templatesContainerStyle} data-for="design-beta-tooltip" data-tip="">
    <Label style={templatesLabelStyle}>Templates</Label>
    <ArrowIcon
      style={templatesArrowStyle}
      color={colors.pink[60]}
      direction="left"
      height={24}
      width={24}
    />
    <Label style={templatesBadgeStyle}>New!</Label>
  </div>
);

export const PresentationStyleRadioGroup = ({
  value,
  options,
  onChange,
  disabled,
  showDesignTabInfo = false,
}) => {
  return (
    <div style={styleContainerStyle}>
      <div style={styleHeaderStyle}>
        <Label style={styleLabelStyle}>Presentation Styles</Label>
        {showDesignTabInfo &&
          <div style={infoBoxStyle}>
            <InfoIcon color={colors.navy[80]} />
            <span style={infoTextStyle}>Please visit the 'Design' tab to select, save or adjust templates.</span>
          </div>
        }
      </div>
      <LabelledRadio style={labelledRadioStyle} value={value} options={options} onChange={onChange} disabled={disabled} />
    </div>
  );
};
